export const API_BASE_API_SSO_URL = process.env.REACT_APP_REST_API;
export const API_CALC_URL = `/tt-calculator`;
export const API_DOC_URL = `/tt-documents`;
